import { Link, Typography } from '@mui/material';

import styled from 'styled-components';

import { Constants } from '@arrived/common';
import { CONFIG } from '@arrived/config';

import { TextWrapper } from '../../../TextWrapper';

const StyledOtherQuestions = styled.div`
  background-color: ${({ theme }) => theme.palette.neutrals.milk};
  padding: ${({ theme }) => theme.spacing(3, 0)};
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .content {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${({ theme }) => theme.spacing(2)};
  }

  .image {
    background-color: ${({ theme }) => theme.palette.primary.main};
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 3rem;
    width: 3rem;
  }

  .text {
    & > *:not(:last-of-type) {
      margin-bottom: ${({ theme }) => theme.spacing(0.5)};
    }
  }

  .link {
    color: ${({ theme }) => theme.palette.primary.main};
  }
`;

export const OtherQuestions = () => {
  return (
    <StyledOtherQuestions>
      <div className="content">
        <div className="image">
          <Typography className="question-mark" variant="h4.bold" color={({ palette }) => palette.neutrals.white}>
            ?
          </Typography>
        </div>
        <div className="text">
          <TextWrapper
            formattedMessageProps={{ id: 'other-questions', defaultMessage: 'Other Questions?' }}
            typographyProps={{
              variant: 'h5.semibold',
            }}
          />
          <Link className="link" href={CONFIG.helpUrl} rel="noopener noreferrer" target="_blank">
            <TextWrapper
              formattedMessageProps={{ id: 'help-center', defaultMessage: 'Visit our help center' }}
              typographyProps={{
                variant: 'h5',
              }}
            />
          </Link>
        </div>
      </div>
    </StyledOtherQuestions>
  );
};
